import { Button } from '@insify/design-system/components';
import { Trash2 } from '@insify/design-system/icons';
import { textSm, textSmSemibold } from '@insify/design-system/typography';
import { formatMoney } from '@insify/global-money';
import { TrackedDiv } from '@objectiv/tracker-react';

import { usePastClaims } from '../../usePastClaims';
import { useClaimOptions } from '../useClaimOptions';

import * as styles from './ClaimsOverviewList.module.css';

import type { PastClaimsContent } from '../../PastClaims';

export const ClaimsOverviewList = ({ country, translations }: PastClaimsContent): JSX.Element => {
  const { getCoverageLabel } = useClaimOptions();
  const [{ pastClaims }, { openPastClaimForm, removeClaim }] = usePastClaims();

  return (
    <>
      {pastClaims.map((claim, index): JSX.Element => {
        return (
          <TrackedDiv
            objectiv={{
              id: claim.id ?? `new-claim-${index}`,
              normalizeId: false,
            }}
            key={claim.id ?? `new-claim-${index}`}
            className={styles.claimCard}
          >
            <dl className={styles.info}>
              <div>
                <dt className={textSm}>{translations.overviewYearLabel}</dt>
                <dd className={textSmSemibold}>{claim.year}</dd>
              </div>
              <div>
                <dt className={textSm}>{translations.overviewCoverageLabel}</dt>
                <dd className={textSmSemibold}>{getCoverageLabel(claim.coverage) ?? ''}</dd>
              </div>
              <div>
                <dt className={textSm}>{translations.overviewAmountLabel}</dt>
                <dd className={textSmSemibold}>{formatMoney(claim.amount, country, { withoutFraction: true })}</dd>
              </div>
            </dl>
            <div className={styles.buttons}>
              <Button kind='secondary' type='button' trackingId='edit' onClick={(): void => openPastClaimForm(claim)}>
                {translations.overviewEdit}
              </Button>
              <Button
                kind='tertiary'
                type='button'
                trackingId='remove'
                aria-label='remove'
                onClick={(): void => removeClaim(claim)}
                leftIcon={<Trash2 />}
              />
            </div>
          </TrackedDiv>
        );
      })}
    </>
  );
};
